import { VOCAB_LANGUAGE_GROUPS } from "@/common/types/vocab";
import { useSettingsStore } from "@/stores";

export default (to, from, next) => {
  const settingsStore = useSettingsStore();

  const isVocabRoute = to.meta.isVocabularyTrainerRoute;
  const isValidLanguage = VOCAB_LANGUAGE_GROUPS.includes(settingsStore.activeLanguageGroup);

  if (isVocabRoute && !isValidLanguage) {
    return next({ name: "vocab-unavailable" });
  }

  next();
};
